import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import PpwrDashboardService from 'src/modules/3rd-party-management/apis/admin/PpwrDashboardService';

export const PPWR_REQUIREMENT_TRACKER_QUERY_KEY = '3rd-party-management-fetch-ppwr-requirement-tracker';

const useRequirementTracker = ({
    t,
}) => {
    return useQuery({
        queryKey: [PPWR_REQUIREMENT_TRACKER_QUERY_KEY],
        queryFn: async () => {
            const service = PpwrDashboardService.getInstance();

            return await service.fetchRequirementTracker();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching PPWR requirement tracker data.'), {
                type: 'error',
            });
        },
    });
};

export default useRequirementTracker;
